import { ReactElement } from "react";
import SortableDynamicTable from "./SortableDynamicTable";

const SortableCardTable = <T,>({
  values,
  columns,
  hasExpansionRow,
}: {
  values: Record<string, string | number | unknown>[];
  columns: ColumnDefinition<T>[];
  hasExpansionRow?: boolean;
}): ReactElement => (
  <SortableDynamicTable
    colorScheme={undefined}
    variant="unstyled"
    style={{
      borderCollapse: "separate",
      borderSpacing: hasExpansionRow ? "0 2px" : "0 16px",
      boxShadow: "0px 0px 4px grey",
      borderRadius: "4px",
      marginBottom: "24px",
    }}
    values={values}
    columns={columns}
    cellPaddingY={3}
    tablePaddingX={{}}
    hasExpansionRow={hasExpansionRow}
  />
);

export default SortableCardTable;
